// function closeDrawer() {
//   document.getElementById('menu-drawer').classList.remove('menu-opening');
//   DetailsMenu.removeAttribute('open');
//   // document.body.style.overflow = 'auto';
// }

// function openDrawer() {
//   document.getElementById('menu-drawer').classList.add('menu-opening');
//   DetailsMenu.setAttribute('open');
//   // document.body.style.overflow = 'hidden';
// }

// // Add an event listener to the "Close Drawer" button
// const closeBtn = document.getElementById('closeDrawerButton');
// const DetailsMenu = document.getElementById('Details-menu-drawer-container');

// const headerIconMenu = document.querySelector('.header__icon--menu');
// closeBtn.addEventListener('click', function () {
//   headerIconMenu.setAttribute('aria-expanded', 'false');
//   closeDrawer();
// });

// DetailsMenu.addEventListener('click', function () {
//   openDrawer();
// });

// Get the elements
const productFormSubmitButtons = document.querySelectorAll(
  ".product-form__submit"
);
const quickAddSubmitButtons = document.querySelectorAll(".quick-add__submit");
const cartDrawer = document.querySelector("cart-drawer");

// Define a function to add the active class to the cart-drawer
function addToCart() {
  cartDrawer.classList.add("active");
  cartDrawer.classList.add("tw-top-0");
  cartDrawer.classList.add("tw-h-full");
}

// Add click event listeners to all elements with class product-form__submit
productFormSubmitButtons.forEach((button) => {
  button.addEventListener("click", addToCart);
});

// Add click event listeners to all elements with class quick-add__submit
quickAddSubmitButtons.forEach((button) => {
  button.addEventListener("click", addToCart);
});

function validateInput(input) {
  input.value = input.value.replace(/[0-9]/g, ""); // Remove numeric characters
}

if (location.pathname == "/cart") {
  document.location.href = "/?return_link=cart";
}
if (location.href.indexOf("return_link=cart") != -1) {
  setTimeout(function () {
    if (document.querySelector("cart-drawer")) {
      document.querySelector("cart-drawer").open();
    }
  }, 0);
  let currentPageUrl = window.location.href.replace("?return_link=cart", "");
  window.history.replaceState({}, document.title, currentPageUrl);
}
